import React, { PropTypes } from 'react';
import moment from "moment";

export default class History extends React.Component {

	componentWillMount() {
		moment.locale('pt-br');
	}

	render () {				
		const { log } = this.props;		
		if ( log.length === 0 ) return null;
		//log.reverse();
		return (
			<div className="log-container">
				{log.map((l, i) =>
					<div className="log-entry" key={i}>
						<span className="log-user">{l.userName}</span>
						{' '}
						{`${l.operation === "INSERT" ? "criou" : "modificou"} este documento ${moment(l.date).format("LLLL")}`}
					</div>
				)}
			</div>
		);
	}
}

History.propTypes = {
	log: PropTypes.array.isRequired
};


// WEBPACK FOOTER //
// ./src/components/Documents/History.js